import { Link } from '@inertiajs/react'
import type { ActionItemStats, ActionItemSummary } from '../../types'

function formatDueDate(dateStr: string | null): string {
  if (!dateStr) return 'No date'
  const date = new Date(dateStr + 'T00:00:00')
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
}

export default function ActionItemsSummaryCard({ stats, teamId }: { stats: ActionItemStats; teamId: number }) {
  return (
    <div className="bg-white rounded-lg border border-stone">
      <div className="flex items-center justify-between px-5 py-4 border-b border-stone">
        <h3 className="text-base font-bold uppercase tracking-widest text-text-secondary">Action Items</h3>
        <Link href={`/teams/${teamId}/action_items`} className="text-sm font-semibold text-text-primary hover:underline">
          View All →
        </Link>
      </div>

      <div className="px-5 pt-4 pb-2 flex gap-4 text-base flex-wrap">
        <span className="text-text-secondary">{stats.open_count} open</span>
        {stats.carried_over_count > 0 && (
          <span className="text-[#B8860B] font-semibold">{stats.carried_over_count} carried over</span>
        )}
        {stats.overdue_count > 0 && (
          <span className="text-[#ED1C24] font-semibold">{stats.overdue_count} overdue</span>
        )}
        <span className="text-text-muted">{stats.completed_this_week} done this week</span>
      </div>

      <div className="p-5 pt-2">
        {stats.urgent_items.length > 0 ? (
          <div className="space-y-2.5">
            {stats.urgent_items.map((ai: ActionItemSummary) => (
              <div key={ai.id} className="flex items-center gap-3">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="text-text-muted flex-shrink-0">
                  <circle cx="12" cy="12" r="10" />
                </svg>
                <span className="text-base text-text-primary flex-1 truncate">{ai.title}</span>
                {ai.overdue && (
                  <span className="text-[12px] font-bold px-1.5 py-0.5 rounded bg-[rgba(237,28,36,0.15)] text-[#ED1C24] flex-shrink-0">
                    Overdue
                  </span>
                )}
                <span className={`text-sm flex-shrink-0 ${ai.overdue ? 'text-[#C41920]' : 'text-text-muted'}`}>
                  {formatDueDate(ai.due_date)}
                </span>
                {ai.owner && (
                  <div
                    className="w-6 h-6 rounded-full bg-charcoal/20 text-text-primary text-[12px] font-bold flex items-center justify-center flex-shrink-0"
                    title={`${ai.owner.first_name} ${ai.owner.last_name}`}
                  >
                    {ai.owner.initials}
                  </div>
                )}
              </div>
            ))}
          </div>
        ) : (
          <p className="text-base text-text-secondary text-center py-4">
            No open action items.{' '}
            <Link href={`/teams/${teamId}/action_items`} className="text-text-primary hover:underline">
              Create one
            </Link>
          </p>
        )}
      </div>
    </div>
  )
}
